import { render } from "./ObjectRenderer.vue?vue&type=template&id=5b4e213e"
import script from "./ObjectRenderer.vue?vue&type=script&lang=js"
export * from "./ObjectRenderer.vue?vue&type=script&lang=js"

import "./ObjectRenderer.vue?vue&type=style&index=0&id=5b4e213e&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__